import { render } from "./CandidateEducationTab.vue?vue&type=template&id=7baa16e4"
import script from "./CandidateEducationTab.vue?vue&type=script&lang=js"
export * from "./CandidateEducationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__